import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class AvdbStatusEventMetadata extends JSONMapped() {

	@jsonProperty()
	series: number;

	@jsonProperty()
	issueName: string;

	@jsonProperty()
	revision: number;

	@jsonProperty()
	format: number;

	@jsonProperty()
	downloadSource: string;

	@jsonProperty()
	state: number;

	@jsonProperty()
	stateDescription: string;

	constructor(data?: Partial<AvdbStatusEventMetadata>) {
		super();
		Object.assign(this, data);
	}
}
